// extracted by mini-css-extract-plugin
export default {"cls1":"PaperInteractions-cls1__w0","cls2":"PaperInteractions-cls2_F9N PaperInteractions-cls1__w0"};